
(function () {
    'use strict';
    angular.module('core')
        .service('userService', userService);

    userService.$inject = ['DataService', 'FilterService', 'dialogService', 'keycloakService'];
    function userService(DataService, FilterService, dialogService, keycloakService) {
        var service = this;
        service.permissions = {};

        return {
            login: login,
            logout: logout,
            getPermissions: getPermissions,
            canEditObject: canEditObject
        };

        function getPermissions() {
            return service.permissions;
        }

        function logout(path) {
            keycloakService.logout(path);
        }

        function canEditObject(objectCreatedByCurrentUser) {
            return service.permissions.editAll || (service.permissions.edit && objectCreatedByCurrentUser);
        }

        function login(path) {
            return keycloakService.login(path).then(function() {
                var resourceAccess = keycloakService.getResourceAccess();
                var permissions = resourceAccess ? resourceAccess.roles : [];
                service.permissions = {
                    view: permissions.includes('RM:V'),
                    viewAll: permissions.includes('RM:VA'),
                    edit: permissions.includes('RM:E'),
                    editAll: permissions.includes('RM:EA'),
                    resolveDateEdit: permissions.includes('RM_RD:E'),
                    resolveDateEditForKD: permissions.includes('RM_RD_KD:E'),
                    seenByLakd: permissions.includes('RM_SBL:E'),
                }

                DataService.loadClassifiers().then(function () {
                    DataService.refreshData(FilterService.filters);
                });
            }, function() {
                dialogService.error('Nepavyko prisijungti.');
            });
        }
    }

})();
